export const STEP = 15;
export const CLASSNAME_ALL_DAY = 'drag-from-allday';
export const GET_EVENTS_DELAY = 500;
